import axios from 'axios';

export const getPlanilhaPlanejamento = (params) => {
    return new Promise((resolve, reject) => {
        const config = {
            url: `/tony/planejamento/material`,
            method: 'get',
            params,
        };

        const handleResponse = (response) => {
            resolve(response.data);
        };

        const handleError = (error) => {
            reject(error);
        };

        axios(config).then(handleResponse).catch(handleError);
    });
};

export const getPlanilhaPlanejamentoSku = (params) => {
    return new Promise((resolve, reject) => {
        const config = {
            url: `/tony/planejamento/sku`,
            method: 'get',
            params,
        };

        const handleResponse = (response) => {
            resolve(response.data);
        };

        const handleError = (error) => {
            reject(error);
        };

        axios(config).then(handleResponse).catch(handleError);
    });
};

export const getPlanilhaSimulacao = (params, data) => {
    return new Promise((resolve, reject) => {
        const config = {
            url: `/tony/relatorio/simulacao`,
            method: 'post',
            params,
            data,
        };

        const handleResponse = (response) => {
            resolve(response.data);
        };

        const handleError = (error) => {
            reject(error);
        };

        axios(config).then(handleResponse).catch(handleError);
    });
};

export const download = async (id) => {
    return new Promise((resolve, reject) => {
        const config = {
            url: `/tony/download/${id}`,
            method: 'get',
        };

        const handleResponse = (response) => {
            resolve(response.data);
        };

        const handleError = (error) => {
            reject(error);
        };

        axios(config).then(handleResponse).catch(handleError);
    });
};
